/**
 * @file
 */

/**
 * Convert the on page text to Knowledge Finance branding and terms.
 * @param companyNameFull
 * @param companyNameShort
 * @param companyURL
 */
export function convertKFText(companyURL: string) {
  const companyNameFull = "Knowledge Finance";
  const companyNameShort = "Knowledge Finance";

   // add noISAConvert to emergency message paragraphs
   $(".homepage-emergencyArticle p").addClass("noISAConvert");

   // paragraphs and textarea (disclosure)
   $("p:not(.noISAConvert), .label-text, textarea.disclosure").each(function () {
      let content = $(this).html();
      content = content.replace(/www.mohela.com/g, companyURL);
      content = content.replace(/mohela.com/g, companyURL);
      content = content.replace(/MOHELA/g, companyNameFull);
      content = content.replace(/loan/g, "contract");
      content = content.replace(/Loan/g, "Contract");
      $(this).html(content);
   });

   // headings and anchors
  $("h1, h2, h3, h4, h5, h6, a:not(.noISAConvert)").each(function () {
      let content = $(this).html();
      content = content.replace(/MOHELA/g, companyNameShort);
      content = content.replace(/loan/g, "contract");
      content = content.replace(/Loan/g, "Contract");
      $(this).html(content);
   });

   // table heading in responsiveTables
      $(".responsiveTable th, .flex-PBL-Data").each(function () {
         let content = $(this).html();
         content = content.replace(/Loan #/, "Contract #");
         content = content.replace(/Loan Sequences/, "Contract #");
         content = content.replace(/Loan Type/, "Contract Type");
         content = content.replace(/Lender/, "Contract Type");
         content = content.replace(/Original Balance/, "Funded Amount")
         content = content.replace(/Current Principal/, "Current Balance");
         content = content.replace(/Original Principal/, "Funding Amount");
         content = content.replace(/Loan Status/, "Contract Status");
         content = content.replace(/Enrolled Loans/, "Enrolled Contracts");
         content = content.replace(/First Disbursement Date/, "Funding Date");
         $(this).html(content);
      });
  $("p.ServicerText").each(function () {
    const content = `${companyNameFull} (“Servicer”), acting on behalf of any current or future holder of any of the Contracts (“Lender”)`
    $(this).html(content);
  });

  $(".hideForISA").each(function () {
    $(this).addClass("ISAhide");
  });
}
